<template>
    <loading
        v-model:active="mostrarLoader"
        color="#001f54"
        loader="dots"
    />

    <section class="section_padding">
        <div class="container">
            <div class="relative-container">
                <!-- Floating Card -->
                <div class="card floating-card d-flex justify-items-center">
                    <div class="text-center mb-2 text-muted d-none d-xl-block">
                        <h5>{{ $t('messages.card_header') }}</h5>
                    </div>
                    
                    <div class="qr-section">
                        <div class="text-center">
                            <img src="@/assets/img/qr_ticket_example.png" alt="QR Code" width="100"/>
                        </div>
                        <div class="id-number" style="font-size:1.5rem;">
                            <span 
                                id="card_code"
                                :class="{ highlight: focusedInput === 'card_code' }"
                            >
                                <b>#######</b>
                            </span>
                            <span 
                                id="card_cvv"
                                :class="{ highlight: focusedInput === 'card_cvv' }"
                            >
                                <b> ####</b>
                            </span>
                        </div>
                    </div>
                    <div class="text-content mt-4 text-center">
                        <span>
                            {{ $t('messages.card_footer') }}
                        </span>
                    </div>
                </div>

                <!-- Form Section -->
                <div class="form-container">
                    <div class="row">
                        <div class="col-lg-8 offset-lg-2 col-md-12 col-sm-12">
                            <div class="common_author_boxed">
                                <Form id="tour_bookking_form_item" @submit="checkSaldo" :validation-schema="saldoSchema">
                                    <div class="common_author_form" style="padding: 80px 0px 0px 0px;">
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                <div class="form-group">
                                                    <Field name="codigo" v-slot="{ field, errors, errorMessage }">
                                                        <input
                                                            id="card_codigo_input"
                                                            type="text"
                                                            class="form-control"
                                                            :placeholder="$t('labels.card_code')"
                                                            @focus="focusedInput = 'card_code'"
                                                            @blur="focusedInput = ''"
                                                            @input="codigo = codigo.toUpperCase()"
                                                            autocomplete="off"
                                                            v-model="codigo"
                                                            v-bind="field" :class="[{'is-invalid': errors.length>0}]" maxlength="7"
                                                        />
                                                        <span class="text-danger">{{ errorMessage }}</span>
                                                    </Field>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                <div class="form-group">
                                                    <Field name="cvv" v-slot="{ field, errors, errorMessage }">
                                                        <input
                                                        id="card_cvv_input"
                                                        type="text"
                                                        class="form-control"
                                                        :placeholder="$t('labels.card_cvv')"
                                                        @focus="focusedInput = 'card_cvv'"
                                                        @blur="focusedInput = ''"
                                                        @input="cvv = cvv.toUpperCase()"
                                                        autocomplete="off"
                                                        v-model="cvv"
                                                        v-bind="field" :class="[{'is-invalid': errors.length>0}]" maxlength="4"
                                                    />
                                                        <span class="text-danger">{{ errorMessage }}</span>
                                                    </Field>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="common_form_submit">
                                            <button class="btn btn_theme btn_md" type="submit">{{ $t('labels.check') }}</button>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                        <div class="col-lg-8 offset-lg-2 mt-4" v-if="saldoConsultado">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="theme_search_form_area" style="box-shadow: none;">
                                        <div class="theme_search_form_tabbtn d-flex justify-content-center">
                                            <ul class="nav nav-tabs" role="tablist">
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link active" id="flights-tab" data-bs-toggle="tab"
                                                        data-bs-target="#flights" type="button" role="tab" aria-controls="flights"
                                                        aria-selected="true" style="border:0!important;"><i class="fas fa-dollar-sign"></i>{{ $t('labels.current_balance') }}</button>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link" id="transactions-tab" data-bs-toggle="tab"
                                                        data-bs-target="#transactions" type="button" role="tab" aria-controls="transactions"
                                                        aria-selected="false" style="border:0!important;" @click="getMovimientos()"><i class="fas fa-credit-card"></i>{{ $t('labels.checks') }}</button>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link" id="tours-tab" data-bs-toggle="tab" data-bs-target="#tours"
                                                        type="button" role="tab" aria-controls="tours" aria-selected="false" style="border:0!important;"><i
                                                            class="fas fa-file"></i>{{ $t('labels.release_tickets') }}</button>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link" id="transfer-tab" data-bs-toggle="tab"
                                                        data-bs-target="#transfer" type="button" role="tab" aria-controls="transfer"
                                                        aria-selected="false" style="border:0!important;"><i class="fas fa-comments-dollar"></i>{{ $t('labels.transfer_tickets') }}</button>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link" id="hotels-tab" data-bs-toggle="tab"
                                                        data-bs-target="#hotels" type="button" role="tab" aria-controls="hotels"
                                                        aria-selected="false" style="border:0!important;"><i class="fas fa-edit"></i>{{ $t('labels.request_recharge') }}</button>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link" id="trazabilidad-tab" data-bs-toggle="tab"
                                                        data-bs-target="#trazabilidad" type="button" role="tab" aria-controls="trazabilidad"
                                                        aria-selected="false" style="border:0!important;"  @click="getTrazabilidad()"><i class="fas fa-business-time"></i>{{ $t('labels.traceability') }}</button>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="tab-content" id="myTabContent">
                                            <div class="tab-pane fade show active" id="flights" role="tabpanel" aria-labelledby="flights-tab">
                                                <div class="row justify-content-center">
                                                    <div class="col-lg-6 col-md-12 col-sm-12">
                                                        <div class="dashboard_top_boxed d-flex justify-content-center">
                                                            <div class="dashboard_top_icon">
                                                                <i class="fas fa-credit-card"></i>
                                                            </div>
                                                            <div class="dashboard_top_text" style="text-align: right;">
                                                                <h3>{{ $t('labels.current_balance') }}</h3>
                                                                <h2>{{ cantidadTickets }} ticket/s</h2>
                                                                <!-- <h5>{{ cantidadTickets }} ticket/s</h5> -->
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-3">
                                                        <div class="dashboard_top_boxed" style="padding: 25px 22px;">
                                                            <div class="dashboard_top_text">
                                                                <h3>{{ $t('labels.released_balance') }}</h3>
                                                                <h1>{{ numberTicketsReleasedInCard }}</h1>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <div class="dashboard_top_boxed" style="padding: 25px 22px;">
                                                            <div class="dashboard_top_text">
                                                                <h3>{{ $t('labels.not_released_balance') }}</h3>
                                                                <h1>{{ cantidadTickets - numberTicketsReleasedInCard }}</h1>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div  class="tab-pane fade" id="transactions" role="tabpanel" aria-labelledby="transactions-tab">
                                                <div class="d-flex justify-content-end">
                                                    <button class="btn btn_theme btn_sm" @click="getMovimientos(excel_btn = '1')"><i class="fa fa-file-excel"></i></button>
                                                </div>

                                                <div class="contact_form">
                                                    <div class="row">
                                                        <div class="col-lg-4 col-md-4 col-sm-12 mb-4">
                                                            <div class="form-group">
                                                                <label class="text-muted">Número Factura</label>
                                                                <input type="text" class="form-control bg_input" placeholder="Buscar por factura" v-model="filtrosMovimiento.numeroDocumento" maxlength="30">
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-4 col-md-4 col-sm-12 mb-4">
                                                            <div class="form-group">
                                                                <label class="text-muted">Número orden</label>
                                                                <input type="text" class="form-control bg_input" placeholder="Buscar por orden" v-model="filtrosMovimiento.numeroOrden" maxlength="30">
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-4 col-md-4 col-sm-12 mb-4">
                                                            <div class="form-group">
                                                                <label class="text-muted">Estado de marcación</label>
                                                                <select class="form-control form-select bg_input" v-model="filtrosMovimiento.estadoMarcacion" placeholder="Seleccione un estado">
                                                                    <option v-for="tipo in tipoEstadoMarcacion" :key="tipo.value" :value="tipo.value">
                                                                    {{ tipo.text }}
                                                                    </option>
                                                                    
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-lg-3 col-md-3 col-sm-12 mb-4">
                                                            <div class="form-group">
                                                                <label class="text-muted">Fecha emisión</label>
                                                                <flat-pickr v-model="filtrosMovimiento.fechaEmisionDesde" class="form-control" placeholder="Desde" :config="dateConfig"/>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 col-md-3 col-sm-12 mb-4">
                                                            <div class="form-group">
                                                                <label class="text-muted">Fecha emisión</label>
                                                                <flat-pickr v-model="filtrosMovimiento.fechaEmisionHasta" class="form-control" placeholder="Hasta" :config="dateConfig"/>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 col-md-3 col-sm-12 mb-4">
                                                            <div class="form-group">
                                                                <label class="text-muted">Fecha marcación</label>
                                                                <flat-pickr v-model="filtrosMovimiento.fechaMarcacionDesde" class="form-control" placeholder="Desde" :config="dateConfig"/>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 col-md-3 col-sm-12 mb-4">
                                                            <div class="form-group">
                                                                <label class="text-muted">Fecha marcación</label>
                                                                <flat-pickr v-model="filtrosMovimiento.fechaMarcacionHasta" class="form-control" placeholder="Hasta" :config="dateConfig"/>
                                                            </div>
                                                        </div>
                                                        
                                                        <div class="col-3">
                                                            <button class="btn btn_theme btn_sm" @click="getMovimientos()">Consultar</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="table-responsive-lg table_common_area" style="user-select: text;">
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th># Orden</th>
                                                                <th>Factura</th>
                                                                <th>Fecha Emisión</th>
                                                                <th>Fecha Marcación</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody v-if="movimientosTarjeta.length > 0">
                                                            <tr v-for="(movimiento, index) in movimientosTarjeta" :key="index">
                                                                <td>
                                                                    <span v-if="movimiento.detalleOrden && movimiento.detalleOrden.orden">
                                                                        {{ movimiento.detalleOrden.orden.codigo }}
                                                                    </span>
                                                                    <span class="badge bg-secondary ms-2" data-bs-toggle="tooltip" title="Secuencia">{{ movimiento.secuencia }}</span>                                                                    
                                                                    <span v-if="movimiento.anulado" class="badge bg-danger ms-2" data-bs-toggle="tooltip" title="Anulado"><i class="fas fa-ban" style="cursor:auto;"></i></span>   
                                                                </td>
                                                                <td>{{ movimiento.numero_documento }}</td>
                                                                <td>
                                                                    <span><i class="fas fa-calendar text-success" style="cursor:auto; margin-right:5px;"></i>{{ new Date(movimiento.fecha_creacion).toLocaleString("pt-BR") }}</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="movimiento.fecha_marcacion"><i class="fas fa-clock text-warning" style="margin-right:5px;"></i>{{ new Date(movimiento.fecha_marcacion).toLocaleString("pt-BR") }}</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        <tbody v-else>
                                                            <tr>
                                                                <td colspan="4" class="text-center">No se encontraron movimientos</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div class="d-flex justify-content-center mt-2">
                                                    <v-pagination
                                                        v-if="movimientosTarjeta.length > 0"
                                                        v-model="page"
                                                        :pages="pagesNumber"
                                                        :range-size="1"
                                                        active-color="#DCEDFF"
                                                        @update:modelValue="updateHandler"
                                                    />
                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="tours" role="tabpanel" aria-labelledby="tours-tab">
                                                <div class="row justify-content-center">
                                                    <div class="col-lg-6 col-md-12 col-sm-12">
                                                        <div class="dashboard_top_boxed d-flex justify-content-center">
                                                            <div class="dashboard_top_icon">
                                                                <i class="fas fa-credit-card"></i>
                                                            </div>
                                                            <div class="dashboard_top_text" style="text-align: right;">
                                                                <h3>{{ $t('labels.recharge_balance') }}</h3>
                                                                <h2>{{ numberTicketsReleasedInCard }}</h2>
                                                                <!-- <h5>{{ numberTicketsReleasedInCard }} {{ $t('labels.released') }}</h5> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <div class="dashboard_top_boxed" style="padding: 25px 22px;">
                                                            <div class="dashboard_top_text">
                                                                <h3>{{ $t('labels.not_released_balance') }}</h3>
                                                                <h1>{{ cantidadTickets - numberTicketsReleasedInCard }}</h1>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row mt-4">
                                                    <Form id="tour_bookking_form_item" @submit="releaseTickets" :validation-schema="releaseTicketSchema" :key="refreshInputKey">
                                                        <div class="row justify-content-center">
                                                            <div class="col-lg-6 col-md-12 col-sm-12">
                                                                <Field name="number_tickets_release" v-slot="{ field, errors, errorMessage }">
                                                                    <input
                                                                        id="number_tickets_release"
                                                                        type="number"
                                                                        min="1"
                                                                        step="1"
                                                                        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                                                                        @wheel.prevent
                                                                        @keydown.up.prevent
                                                                        @keydown.down.prevent
                                                                        class="form-control"
                                                                        :placeholder="$t('labels.tickets_number')"
                                                                        v-model="numberTicketsRelease"
                                                                        v-bind="field" :class="[{'is-invalid': errors.length>0}]"
                                                                    />
                                                                    <span class="text-danger">{{ errorMessage }}</span>
                                                                </Field>
                                                            </div>
                                                            <div class="col-lg-3 col-md-12 col-sm-12 text-center">
                                                                <button class="btn btn_theme btn_md w-100" type="submit">{{ $t('labels.release') }}</button>
                                                            </div>
                                                        </div>
                                                    </Form>
                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="hotels" role="tabpanel" aria-labelledby="hotels-tab">
                                                <div class="row justify-content-center">
                                                    <div class="col-lg-6 col-md-12 col-sm-12">
                                                        <div class="dashboard_top_boxed d-flex justify-content-center">
                                                            <div class="dashboard_top_icon">
                                                                <i class="fas fa-credit-card"></i>
                                                            </div>
                                                            <div class="dashboard_top_text" style="text-align: right;">
                                                                <h3>{{ $t('labels.current_balance') }}</h3>
                                                                <h2>{{ cantidadTickets }} ticket/s</h2>
                                                                <!-- <h5>{{ cantidadTickets }} ticket/s</h5> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row mt-4" style="user-select: text;">
                                                    <Form id="tour_bookking_form_item" @submit="rechargeTickets" :validation-schema="rechargeTicketSchema" :key="refreshInputKey">
                                                        <div class="row justify-content-center">
                                                            <div class="booking_tour_form">
                                                                <h3 class="heading_theme">{{ $t('labels.recharge_info') }}</h3>
                                                                <div class="tour_booking_form_box row" style="box-shadow: none;">
                                                                    <div class="col-lg-8 col-md-12 col-sm-12">
                                                                        <div class="row">
                                                                            <div class="col-lg-8 col-md-12 col-sm-12">
                                                                                <Field name="names_recharge" v-slot="{ field, errors, errorMessage }">
                                                                                    <input
                                                                                        id="names_recharge"
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        :placeholder="$t('labels.names_recharge')"
                                                                                        v-model="namesRecharge"
                                                                                        maxlenght="100"
                                                                                        v-bind="field" :class="[{'is-invalid': errors.length>0}]"
                                                                                    />
                                                                                    <span class="text-danger">{{ errorMessage }}</span>
                                                                                </Field>
                                                                            </div>
                                                                            <div class="col-lg-4 col-md-12 col-sm-12">
                                                                                <Field name="number_tickets_recharge" v-slot="{ field, errors, errorMessage }">
                                                                                    <input
                                                                                        id="number_tickets_recharge"
                                                                                        type="number"
                                                                                        min="1"
                                                                                        step="1"
                                                                                        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                                                                                        @wheel.prevent
                                                                                        @keydown.up.prevent
                                                                                        @keydown.down.prevent
                                                                                        class="form-control"
                                                                                        :placeholder="$t('labels.tickets_number')"
                                                                                        v-model="numberTicketsRecharge"
                                                                                        v-bind="field" :class="[{'is-invalid': errors.length>0}]"
                                                                                    />
                                                                                    <span class="text-danger">{{ errorMessage }}</span>
                                                                                </Field>
                                                                            </div>
                                                                        </div>

                                                                        <div class="tour_booking_form_box mt-4">
                                                                            <!-- <h5 class="heading_theme">{{ $t('titles.payment_method') }}</h5> -->
                                                                            <div class="booking_payment_boxed">
                                                                                <div class="form-check">
                                                                                    <input class="form-check-input" type="radio" name="flexRadioDefault"
                                                                                        id="flexRadioDefault1" value="TRANSF" v-model="paymentMethodRecharge">
                                                                                    <label class="form-check-label" for="flexRadioDefault1">
                                                                                        Transferencia bancaria
                                                                                    </label>
                                                                                </div>
                                                                                <div class="form-check">
                                                                                    <input class="form-check-input" type="radio" name="flexRadioDefault"
                                                                                        id="flexRadioDefault2" value="DEP" v-model="paymentMethodRecharge">
                                                                                    <label class="form-check-label" for="flexRadioDefault2">
                                                                                        Depósito
                                                                                    </label>
                                                                                </div>
                                                                                <div class="form-check">
                                                                                    <input class="form-check-input" type="radio" name="flexRadioDefault"
                                                                                        id="flexRadioDefault3" value="OTROS" v-model="paymentMethodRecharge">
                                                                                    <label class="form-check-label" for="flexRadioDefault3">
                                                                                        Otros
                                                                                    </label>
                                                                                    <input
                                                                                        v-if="paymentMethodRecharge === 'OTROS'"
                                                                                        id="payment_method_otros_recharge"
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="Especifique el método de pago"
                                                                                        v-model="paymentMethodOtrosRecharge"
                                                                                        maxlenght="200"
                                                                                    />
                                                                                </div>                                                                    
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                    <div class="col-lg-4 col-md-12 col-sm-12">
                                                                        <div class="tour_detail_right_sidebar">
                                                                            <div class="tour_details_right_boxed">
                                                                                <div class="tour_details_right_box_heading">
                                                                                    <h5 class="heading_theme">{{ $t('titles.details') }}</h5>
                                                                                </div>
                                                
                                                                                <div class="tour_booking_amount_area">
                                                                                    <ul>
                                                                                        <li>Ticket/s x {{ numberTicketsRecharge }} <span>$ {{ calculateTotal }}</span></li>
                                                                                        <!-- <li>Discount <span>-10%</span></li> -->
                                                                                        <!-- <li>{{ $t('labels.tax') }} <span>$ 0.00</span></li> -->
                                                                                    </ul>
                                                                            
                                                                                    
                                                                                    <div class="total_subtotal_booking">
                                                                                        <h6>{{ $t('labels.total') }} <span>$ {{ calculateTotal }}</span> </h6>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-12 mb-4">
                                                                        <div class="d-flex align-items-center"><i class="fas fa-info-circle text-muted" style="font-size:15px;"></i><p style="font-size: 14px; margin-left:3px;">{{ $t('labels.billing_same_person')}} {{duenoTarjeta}}</p></div>

                                                                        <div class="form-check write_spical_check">
                                                                            <input class="form-check-input" type="checkbox" id="flexCheckDefaultf2" v-model="facturarOtraPersona">
                                                                            <label class="form-check-label" for="flexCheckDefaultf2">
                                                                                <span class="main_spical_check">
                                                                                    <span>{{ $t('messages.confirm_billing_other') }}</span>
                                                                                </span>
                                                                            </label>
                                                                        </div>

                                                                        <div class="tour_booking_form_box" v-if="facturarOtraPersona">
                                                                                <div class="row">
                                                                                    <div class="col-lg-6">
                                                                                        <div class="form-group">
                                                                                            <Field name="facturacion_names" v-slot="{ field, errors, errorMessage }">
                                                                                                <input type="text" class="form-control bg_input" :placeholder="$t('labels.names')" v-model="datosFacturacion.names" v-bind="field" :class="[{'is-invalid': errors.length>0}]" maxlength="200" @input="handleNamesInput($event, field)" autocomplete="off">
                                                                                                <span class="text-danger">{{ errorMessage }}</span>
                                                                                            </Field>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-lg-6">
                                                                                        <div class="form-group">
                                                                                            <Field name="facturacion_email" v-slot="{ field, errors, errorMessage }">
                                                                                                <input type="text" class="form-control bg_input" :placeholder="$t('labels.email')" v-model="datosFacturacion.email" v-bind="field" :class="[{'is-invalid': errors.length>0}]" maxlength="100" @input="handleEmailInput($event, field)" autocomplete="off">
                                                                                                <span class="text-danger">{{ errorMessage }}</span>
                                                                                            </Field>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-lg-6">
                                                                                        <div class="form-group">
                                                                                            <vue-tel-input v-model="datosFacturacion.mobileNumber" v-bind="bindProps" @country-changed="onChangeTelCountry" @input="sanitizePhoneInput">
                                                                                                <template v-slot:arrow-icon>
                                                                                                    <span>{{ open ? '▲' : '▼' }}</span>
                                                                                                </template>
                                                                                            </vue-tel-input>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-lg-6">
                                                                                        <div class="form-group">
                                                                                            <select class="form-control form-select bg_input" v-model="datosFacturacion.country">
                                                                                                <option v-for="pais in paisOptions" :key="pais.value" :value="pais.value">
                                                                                                  {{ pais.text }}
                                                                                                </option>
                                                                                              </select>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-lg-6">
                                                                                        <div class="form-group">
                                                                                            <Field name="facturacion_id_number" v-slot="{ field, errors, errorMessage }">
                                                                                                <input type="text" class="form-control bg_input" :placeholder="$t('labels.id_number')" v-model="datosFacturacion.idNumber" v-bind="field" :class="[{'is-invalid': errors.length>0}]" maxlength="20"  @input="handleIdNumberInput($event, field)" autocomplete="off">
                                                                                                <span class="text-danger">{{ errorMessage }}</span>
                                                                                            </Field>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-lg-6">
                                                                                        <div class="form-group">
                                                                                            <input type="text" class="form-control bg_input" :placeholder="$t('labels.state_province')" v-model="datosFacturacion.stateProvince" maxlength="100" autocomplete="off">
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="row">
                                                                                    <div class="col-lg-12">
                                                                                        <div class="form-group">
                                                                                            <input type="text" class="form-control bg_input" :placeholder="$t('labels.street_address')" v-model="datosFacturacion.streetAddress" maxlength="500" autocomplete="off">
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-12 mb-4">
                                                                        <div class="tour_package_details_bar_list mb-1">
                                                                            <h5>Cuentas bancarias</h5>
                                                                        </div>
                                                                        <div class="row">
                                                                            <div class="col-xl-6 col-md-12 col-sm-12 mt-2">
                                                                                <div class="tour_booking_form_box">                                                                           
                                                                                    <div class="text-center">
                                                                                        <a href="#">
                                                                                            <img src="@/assets/img/payment/banco-pacifico.png" alt="banco pacifico" height="100" width="100">
                                                                                        </a>
                                                                                    </div>
                                                                                    <div class="text-center mt-1">
                                                                                        <b>Banco del Pacífico Cuenta Corriente #7844905</b><br>
                                                                                        BUZZTRANS COMPAÑÍA DE TRANSPORTE DE PASAJEROS S.A.<br>
                                                                                        <b>R.U.C.: </b>0992830093001<br>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div class="col-xl-6 col-md-12 col-sm-12 mt-2">
                                                                                <div class="tour_booking_form_box">                                                                                
                                                                                    <div class="text-center">
                                                                                        <a href="#">
                                                                                            <img src="@/assets/img/payment/banco-pichincha.png" alt="banco pichincha" height="100" width="190">
                                                                                        </a>
                                                                                    </div>
                                                                                    <div class="text-center mt-1">
                                                                                        <b>Banco Pichincha Cuenta Corriente #2100062629</b><br>
                                                                                        BUZZTRANS COMPAÑÍA DE TRANSPORTE DE PASAJEROS S.A.<br>
                                                                                        <b>R.U.C.: </b>0992830093001<br>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-12">
                                                                        <div class="tour_package_details_bar_list">
                                                                            <h5>Consideraciones</h5>
                                                                            <ul>
                                                                                <li><i class="fas fa-circle"></i>Favor tener en cuenta los costos de transferencia de su entidad bancaria, para que el valor que se acredite en las cuentas de BUZZTRANS sea el correspondiente.</li>
                                                                                <li><i class="fas fa-circle"></i>Los tickets de operador son válidos para todas las rutas y no tienen fecha de caducidad.</li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="booking_tour_form_submit">
                                                            <Field name="terminos_condiciones" v-slot="{ field, errorMessage }" type="checkbox">
                                                                <div class="form-check write_spical_check">
                                                                    <input class="form-check-input" type="checkbox" id="flexCheckDefaultf1" v-model="terminosCondicionesRecharge">
                                                                    <label class="form-check-label" for="flexCheckDefaultf1">
                                                                        <span class="main_spical_check">
                                                                            <span>{{ $t('messages.read_accept') }} <a href="https://tickets.lobitogalapagos.com/card-terms" target="_blank" class="text-primary"><b>{{ $t('messages.terms_conditions') }}</b></a></span>
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                                <span class="text-danger">{{ errorMessage }}</span>
                                                            </Field>
                            
                                                            <div class="d-flex justify-content-center mt-4">
                                                                <button type="submit" class="btn btn_theme btn_md">{{ $t('labels.request') }}</button>
                                                            </div>
                                                        </div>
                                                    </Form>
                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="transfer" role="tabpanel" aria-labelledby="transfer-tab">
                                                <Form id="transfer_form" @submit="transferTickets" :validation-schema="transferTicketSchema" :key="refreshInputKey">
                                                    <div class="row justify-content-center">
                                                        <div class="col-lg-5 col-md-12 col-sm-12">
                                                            <div class="dashboard_top_boxed d-flex justify-content-center">
                                                                <div class="dashboard_top_icon">
                                                                    <i class="fas fa-credit-card"></i>
                                                                </div>
                                                                <div class="dashboard_top_text" style="text-align: right;">
                                                                    <h3>Origen</h3>
                                                                    <h2>{{ codigo.toUpperCase() }}</h2>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-1 d-none d-xl-block d-md-block text-center" style="font-size:40px;">
                                                            <i class="fas fa-arrow-right" style="margin-top: 60px;"></i>
                                                        </div>
                                                        <div class="col-lg-12 d-block d-xl-none d-md-none text-center" style="font-size:40px;">
                                                            <i class="fas fa-arrow-down"></i>
                                                        </div>

                                                        <div class="col-lg-5 col-md-12 col-sm-12">
                                                            <div class="dashboard_top_boxed d-flex justify-content-center">
                                                                <div class="dashboard_top_icon">
                                                                    <i class="fas fa-credit-card"></i>
                                                                </div>
                                                                <div class="dashboard_top_text" style="text-align: right;">
                                                                    <h3>Destino</h3>
                                                                    <Field name="destiny_card_code" v-slot="{ field, errors, errorMessage }">
                                                                        <input
                                                                            id="destiny_card_code"
                                                                            type="text"
                                                                            class="form-control"
                                                                            placeholder="Código"
                                                                            @input="transferData.destinyCardCode = transferData.destinyCardCode.toUpperCase()"
                                                                            autocomplete="off"
                                                                            v-model="transferData.destinyCardCode"
                                                                            v-bind="field" :class="[{'is-invalid': errors.length>0}]" maxlength="7"
                                                                        />
                                                                        <span class="text-danger">{{ errorMessage }}</span>
                                                                    </Field>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-6 col-md-12 col-sm-12 mt-4">
                                                            <div class="d-flex align-items-center justify-content-center"><i class="fas fa-info-circle text-muted" style="font-size:15px;"></i><p style="font-size: 14px; margin-left:3px;">Solo es posible transferir los tickets no liberados</p></div>

                                                            <div class="tour_detail_right_sidebar">
                                                                <div class="tour_details_right_boxed">
                                                                    <div class="tour_details_right_box_heading">
                                                                        <h5 class="heading_theme">Detalles tarjeta de origen</h5>
                                                                    </div>
                                    
                                                                    <div class="tour_booking_amount_area">
                                                                        <ul>
                                                                            <li>Tickets liberados <span>{{ numberTicketsReleasedInCard }}</span></li>
                                                                            <li>Tickets no liberados <span>{{ cantidadTickets-numberTicketsReleasedInCard}}</span></li>
                                                                        </ul>
                                                                
                                                                        
                                                                        <div class="total_subtotal_booking">
                                                                            <h6>Total <span>{{ cantidadTickets }}</span> </h6>
                                                                        </div>

                                                                        <div class="total_subtotal_booking mt-3">
                                                                                <Field name="number_tickets_transfer" v-slot="{ field, errors, errorMessage }">
                                                                                    <input
                                                                                        id="number_tickets_transfer"
                                                                                        type="number"
                                                                                        min="1"
                                                                                        step="1"
                                                                                        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                                                                                        @wheel.prevent
                                                                                        @keydown.up.prevent
                                                                                        @keydown.down.prevent
                                                                                        class="form-control"
                                                                                        placeholder="Tickets a transferir"
                                                                                        v-model="transferData.ticketsToTransfer"
                                                                                        v-bind="field" :class="[{'is-invalid': errors.length>0}]"
                                                                                    />
                                                                                    <span class="text-danger">{{ errorMessage }}</span>
                                                                                </Field>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row mt-4">
                                                        <div class="col-12 text-center">
                                                            <button class="btn btn_theme btn_md" type="submit">{{ $t('labels.transfer') }}</button>
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>

                                            <div  class="tab-pane fade" id="trazabilidad" role="tabpanel" aria-labelledby="trazabilidad-tab">
                                                <div class="table-responsive-lg table_common_area" style="user-select: text;">
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th>Fecha</th>
                                                                <th>Actividad</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody v-if="detallesTrazabilidad.length > 0">
                                                            <tr v-for="(detalle, index) in detallesTrazabilidad" :key="index">                                               
                                                                <td>
                                                                    <span><i class="fas fa-calendar text-success" style="cursor:auto; margin-right:5px;"></i>{{ new Date(detalle.fechaHora).toLocaleString("pt-BR") }}</span>
                                                                </td>
                                                                <td>{{ detalle.descripcion }}</td>
                                                            </tr>
                                                        </tbody>
                                                        <tbody v-else>
                                                            <tr>
                                                                <td colspan="4" class="text-center">No existe información para mostrar</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div class="d-flex justify-content-center mt-2">
                                                    <v-pagination
                                                        v-if="detallesTrazabilidad.length > 0"
                                                        v-model="pageTrazabilidad"
                                                        :pages="pagesNumberTrazabilidad"
                                                        :range-size="1"
                                                        active-color="#DCEDFF"
                                                        @update:modelValue="updateHandlerTrazabilidad"
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from '@/axios'
import { Field, Form } from 'vee-validate';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import paises from '@/assets/utils/paises.js';
import { obtenerTipoPersonaFacturacion } from "@/assets/utils/actions.js";
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import flatPickr from "vue-flatpickr-component";
import actions from "@/assets/utils/utils";

export default {
    name: "ConsultarSaldoArea",
    components:{
        Form,
        Field,
        Loading,
        VueTelInput,
        VPagination,
        flatPickr
    },
    data() {
        return {
            focusedInput: "",
            mostrarLoader: false,
            codigo: "",
            cvv: "",
            saldoSchema: {
                codigo: 'required',
                cvv: 'required',
            },
            releaseTicketSchema:{
                number_tickets_release: 'required',
            },

            rechargeTicketSchema:{
                names_recharge: 'required',
                number_tickets_recharge: 'required',
                // facturacion_names: 'required',
                //facturacion_id_number: 'required',
                // facturacion_email: 'required',
                //terminos_condiciones: 'terminosCondiciones',
            },

            transferTicketSchema: {
                destiny_card_code: 'required',
                number_tickets_transfer: 'required',
            },

            saldoConsultado: false,
            saldo: 0,
            cantidadTickets: 0,

            numberTicketsRelease: "",
            numberTicketsReleasedInCard: 0,
            duenoTarjeta: "",

            transferData: {
                destinyCardCode: '',
                ticketsToTransfer: null,
            },

            namesRecharge: "",
            numberTicketsRecharge: 0,
            paymentMethodRecharge: "TRANSF",
            paymentMethodOtrosRecharge: "",
            terminosCondicionesRecharge: false,

            refreshInputKey: 0,

            facturarOtraPersona: false,
            datosFacturacion: {
                names: '',
                idNumber: '',
                email: '',
                mobileNumber: '',
                country: 'Ecuador',
                stateProvince: '',
                streetAddress: '',
                terminosCondiciones: true,
                tipoPersona: ''
            },
            paisOptions: paises.paises,

            bindProps: {
                mode: "international",
                autoformat: true,
                dropdownOptions: {
                    showDialCode: false,
                    showDialCodeInList: true,
                    showDialCodeInSelection: true,
                    showFlags: true,
                    showSearchBox: true
                },
                inputOptions: {
                    placeholder: 'Tel.',
                    styleClasses: 'form-control bg_input',
                },
                defaultCountry: 'EC'
            },

            movimientosTarjeta: [],

            page: 1,
            perPage: 15,
            pagesNumber: 1,

            filtrosMovimiento: {
                numeroDocumento: "",
                numeroOrden: "",
                estadoMarcacion: "all",
                fechaEmisionDesde: "",
                fechaEmisionHasta: "",
                fechaMarcacionDesde: "",
                fechaMarcacionHasta: "",
            },
            tipoEstadoMarcacion: [{value: "all", text: "Todos"}, {value: "M", text: "Marcado"}, {value: "NM", text: "No marcado"}],
            dateConfig: {
                wrap: true, // set wrap to true only when using 'input-group'
                dateFormat: 'd/m/Y',
            },

            detallesTrazabilidad: [],
            pageTrazabilidad: 1,
            perPageTrazabilidad: 15,
            pagesNumberTrazabilidad: 1,
        }
    },
    methods: {
        checkSaldo(){
            this.openLoadingInDiv()
            // this.saldoConsultado = false
            axios
            .post("api", {
            query: `query getSaldoTarjeta($codigo: String!, $cvv: String!){
                      getSaldoTarjeta(codigo:$codigo, cvv:$cvv){
                          saldo
                          cantidadTickets
                          boletosLiberados
                          duenoTarjeta
                          status
                          message
                      }
                  }`,
                variables: {
                    codigo: this.codigo,
                    cvv: this.cvv
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.data.getSaldoTarjeta.status === 'success') {
                        this.saldoConsultado = true
                        this.saldo = response.data.data.getSaldoTarjeta.saldo
                        this.cantidadTickets = response.data.data.getSaldoTarjeta.cantidadTickets
                        this.numberTicketsReleasedInCard = response.data.data.getSaldoTarjeta.boletosLiberados
                        this.duenoTarjeta = response.data.data.getSaldoTarjeta.duenoTarjeta

                        // this.getMovimientos()

                        window.scrollTo(0, document.body.scrollHeight);
                    } else {
                        this.showErrorAlert(response.data.data.getSaldoTarjeta.message)
                    }
                }
                this.closeLoadingInDiv()
            })
        },
        openLoadingInDiv(){
            this.mostrarLoader = true
        },
        closeLoadingInDiv(){
            this.mostrarLoader = false
        },
        showErrorAlert(message) {
            this.$swal({
                title: 'Error',
                text: message,
                icon: 'error',
                confirmButtonColor: '#001F54',
            });
        },
        releaseTickets(){
            this.$swal({
                title: this.$t('labels.release_tickets'),
                text: this.$t('messages.sure_release_tickets'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#001F54',
                confirmButtonText: this.$t('labels.accept'),
                cancelButtonText: this.$t('labels.cancel'),
            }).then(result => {
                if (result.value) {
                    this.openLoadingInDiv()
                    axios
                    .post("api", {
                    query: `mutation liberarBoletos($codigo: String!, $cvv: String!, $cantidad: Int!){
                            liberarBoletos(codigo:$codigo, cvv:$cvv, cantidad:$cantidad){
                                status
                                message
                            }
                        }`,
                        variables: {
                            codigo: this.codigo,
                            cvv: this.cvv,
                            cantidad: this.numberTicketsRelease
                        },
                    })
                    .then((response) => {
                        if (response.status === 200) {
                            if (response.data.data.liberarBoletos.status === 'success') {
                                this.numberTicketsRelease = ""
                                this.refreshInputKey += 1
                                this.$swal({
                                    title: this.$t('labels.release_tickets'),
                                    text: response.data.data.liberarBoletos.message,
                                    icon: 'success',
                                    confirmButtonColor: '#001F54',
                                    confirmButtonText: this.$t('labels.accept'),
                                })
                                this.checkSaldo()
                            } else {
                                this.showErrorAlert(response.data.data.liberarBoletos.message)
                            }
                        }
                        this.closeLoadingInDiv()
                    })
                }
            });
        },
        rechargeTickets(){
            this.obtenerTipoPersona()

            // Check terms and conditions
            if (!this.terminosCondicionesRecharge) {
                this.showErrorAlert(this.$t('messages.terms_conditions_error'));
                return;
            }

            this.$swal({
                title: this.$t('labels.request_recharge'),
                text: this.$t('messages.sure_request_recharge'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#001F54',
                confirmButtonText: this.$t('labels.accept'),
                cancelButtonText: this.$t('labels.cancel'),
            }).then(result => {
                if (result.value) {
                    this.openLoadingInDiv()
                    // this.obtenerTipoPersona();
                    axios
                    .post("api", {
                    query: `mutation solicitarRecarga($codigo: String!, $cvv: String!, $nombres: String!, $cantidad: Int!, $metodoPago: String!, $otros: String, $facturarOtraPersona: Boolean!, $datosFacturacion: DatosFacturacionInput!){
                            solicitarRecarga(codigo:$codigo, cvv:$cvv, nombres:$nombres, cantidad:$cantidad, metodoPago:$metodoPago, otros:$otros, facturarOtraPersona:$facturarOtraPersona, datosFacturacion:$datosFacturacion){
                                status
                                message
                            }
                        }`,
                        variables: {
                            codigo: this.codigo,
                            cvv: this.cvv,
                            nombres: this.namesRecharge,
                            cantidad: this.numberTicketsRecharge,
                            metodoPago: this.paymentMethodRecharge,
                            otros: this.paymentMethodOtrosRecharge,
                            facturarOtraPersona: this.facturarOtraPersona,
                            datosFacturacion: this.datosFacturacion,
                        },
                    })
                    .then((response) => {
                        if (response.status === 200) {
                            if (response.data.data.solicitarRecarga.status === 'success') {
                                this.namesRecharge = ""
                                this.numberTicketsRecharge = ""
                                this.paymentMethodRecharge = "TRANSF"
                                this.paymentMethodOtrosRecharge = ""
                                this.terminosCondicionesRecharge = false
                                this.facturarOtraPersona = false
                                this.datosFacturacion = {
                                    names: '',
                                    idNumber: '',
                                    email: '',
                                    mobileNumber: '',
                                    country: 'Ecuador',
                                    stateProvince: '',
                                    streetAddress: '',
                                    terminosCondiciones: true,
                                    tipoPersona: ''
                                }
                                this.refreshInputKey += 1
                                this.$swal({
                                    title: this.$t('labels.request_recharge'),
                                    text: response.data.data.solicitarRecarga.message,
                                    icon: 'success',
                                    confirmButtonColor: '#001F54',
                                    confirmButtonText: this.$t('labels.accept'),
                                })
                            } else {
                                this.showErrorAlert(response.data.data.solicitarRecarga.message)
                            }
                        }
                        this.closeLoadingInDiv()
                    })
                }
            });
        },
        onChangeTelCountry(object){
            this.datosFacturacion.country = object.name
        },
        obtenerTipoPersona(){
          const cedulaRuc = this.datosFacturacion.idNumber
          this.datosFacturacion.tipoPersona = obtenerTipoPersonaFacturacion(cedulaRuc)
        },
        handleEmailInput(event, field) {
            const sanitizedValue = event.target.value.replace(/\|/g, '');
            this.datosFacturacion.email = sanitizedValue;
            field.value = sanitizedValue; // sincroniza con vee-validate
        },
        handleNamesInput(event, field) {
            // Solo letras sin tildes, "ñ", y espacios
            const sanitizedValue = event.target.value.replace(/[^a-zA-ZñÑ\s]/g, '');
            this.datosFacturacion.names = sanitizedValue;
            field.value = sanitizedValue;
        },
        handleIdNumberInput(event, field) {
            // Solo letras sin tildes, números
            const sanitizedValue = event.target.value.replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s/g, '');
            this.datosFacturacion.idNumber = sanitizedValue;
            field.value = sanitizedValue;
        },
        sanitizePhoneInput(event) {
            // Remove the '|' character from the input
            this.datosFacturacion.mobileNumber = this.datosFacturacion.mobileNumber.replace(/\|/g, '');
        },
        getMovimientos(excel_btn = "", desde = 0, hasta = 15, pagina_actual = 1){
            this.openLoadingInDiv()
            // this.saldoConsultado = false
            axios
            .post("api", {
            query: `query getAllBoletos($numeroDocumento: String, $numeroOrden: String, $estado: String, $fechaEmisionDesde: String, $fechaEmisionHasta: String, $fechaMarcacionDesde: String, $fechaMarcacionHasta: String, $codigo: String!, $cvv: String!, $excel: String, $desde: Int!, $hasta: Int!){
                      getAllBoletos(numeroDocumento: $numeroDocumento, numeroOrden: $numeroOrden, estado: $estado, fechaEmisionDesde: $fechaEmisionDesde, fechaEmisionHasta: $fechaEmisionHasta, fechaMarcacionDesde: $fechaMarcacionDesde, fechaMarcacionHasta: $fechaMarcacionHasta, codigo: $codigo, cvv: $cvv, excel:$excel, desde: $desde, hasta: $hasta){
                        boletos{
                            fecha_creacion: fechaCreacion,
                            fecha_marcacion: fechaMarcacion,
                            secuencia,
                            numero_documento: numeroDocumento,
                            token,
                            marcado,
                            anulado,
                            detalleOrden{
                                orden{
                                    codigo
                                }
                            }
                        },
                        dataarchivo,
                        total,
                        status,
                        message
                      }
                  }`,
                variables: {
                    estado: this.filtrosMovimiento.estadoMarcacion,
                    numeroOrden: this.filtrosMovimiento.numeroOrden,
                    numeroDocumento: this.filtrosMovimiento.numeroDocumento,
                    fechaEmisionDesde: this.filtrosMovimiento.fechaEmisionDesde,
                    fechaEmisionHasta: this.filtrosMovimiento.fechaEmisionHasta,
                    fechaMarcacionDesde: this.filtrosMovimiento.fechaMarcacionDesde,
                    fechaMarcacionHasta: this.filtrosMovimiento.fechaMarcacionHasta,
                    codigo: this.codigo,
                    cvv: this.cvv,
                    excel: excel_btn,
                    desde,
                    hasta,
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.data.getAllBoletos.status === 'success') {
                        if (response.data.data.getAllBoletos.boletos) {
                            this.movimientosTarjeta = response.data.data.getAllBoletos.boletos;
                            this.pagesNumber = Math.ceil(response.data.data.getAllBoletos.total / this.perPage);
                        }
                        else{
                            const data = response.data.data.getAllBoletos.dataarchivo;
                            if (excel_btn === "1") {
                                actions.cargarArchivos(
                                    data,
                                    "Movimientos de tarjeta "+this.codigo+".xlsx",
                                    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64"
                                );
                            }
                        }
                    } else {
                        this.showErrorAlert(response.data.data.getAllBoletos.message)
                    }
                }
                this.closeLoadingInDiv()
            })
        },

        getTrazabilidad(desde = 0, hasta = 15, pagina_actual = 1){
            this.openLoadingInDiv()
            axios
            .post("api", {
            query: `query getTrazabilidadTarjeta($codigo: String!, $cvv: String!, $desde: Int!, $hasta: Int!){
                      getTrazabilidadTarjeta(codigo:$codigo, cvv:$cvv, desde: $desde, hasta: $hasta){
                        detalles{
                            fechaHora,
                            descripcion
                        },
                        total,
                        status,
                        message
                      }
                  }`,
                variables: {
                    codigo: this.codigo,
                    cvv: this.cvv,
                    desde,
                    hasta,
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.data.getTrazabilidadTarjeta.status === 'success') {
                        if (response.data.data.getTrazabilidadTarjeta.detalles) {
                            this.detallesTrazabilidad = response.data.data.getTrazabilidadTarjeta.detalles;
                            this.pagesNumberTrazabilidad = Math.ceil(response.data.data.getTrazabilidadTarjeta.total / this.perPageTrazabilidad);
                        }
                    } else {
                        this.showErrorAlert(response.data.data.getTrazabilidadTarjeta.message)
                    }
                }
                this.closeLoadingInDiv()
            })
        },

        updateHandler(value){
            const pagina_actual = value;
            // this.currentPage = pagina_actual
            const limite_superior = value * this.perPage;
            const limite_inferior = (value - 1) * this.perPage;
            const desde = limite_inferior;
            const hasta = limite_superior;
    
            this.getMovimientos("", desde, hasta, pagina_actual);
        },

        updateHandlerTrazabilidad(value){
            const pagina_actual = value;
            // this.currentPage = pagina_actual
            const limite_superior = value * this.perPageTrazabilidad;
            const limite_inferior = (value - 1) * this.perPageTrazabilidad;
            const desde = limite_inferior;
            const hasta = limite_superior;
    
            this.getTrazabilidad(desde, hasta, pagina_actual);
        },

        transferTickets() {
            this.$swal({
                title: this.$t('labels.transfer_tickets'),
                text: this.$t('messages.sure_transfer_tickets'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#001F54',
                confirmButtonText: this.$t('labels.accept'),
                cancelButtonText: this.$t('labels.cancel'),
            }).then(result => {
                if (result.value) {
                    this.openLoadingInDiv()
                    axios
                    .post("api", {
                    query: `mutation transferirBoletos($origenCodigo: String!, $origenCvv: String!, $destinoCodigo: String!, $cantidad: Int!){
                            transferirBoletos(origenCodigo:$origenCodigo, origenCvv:$origenCvv, destinoCodigo:$destinoCodigo, cantidad:$cantidad){
                                status
                                message
                            }
                        }`,
                        variables: {
                            origenCodigo: this.codigo,
                            origenCvv: this.cvv,
                            destinoCodigo: this.transferData.destinyCardCode.toUpperCase(),
                            cantidad: parseInt(this.transferData.ticketsToTransfer)
                        },
                    })
                    .then((response) => {
                        if (response.status === 200) {
                            if (response.data.data.transferirBoletos.status === 'success') {
                                this.transferData = {
                                    destinyCardCode: '',
                                    ticketsToTransfer: null,
                                }
                                this.refreshInputKey += 1
                                this.$swal({
                                    title: this.$t('labels.transfer_tickets'),
                                    text: response.data.data.transferirBoletos.message,
                                    icon: 'success',
                                    confirmButtonColor: '#001F54',
                                    confirmButtonText: this.$t('labels.accept'),
                                })
                                this.checkSaldo()
                            } else {
                                this.showErrorAlert(response.data.data.transferirBoletos.message)
                            }
                        }
                        this.closeLoadingInDiv()
                    })
                }
            });
        },
    },
    computed:{
        calculateTotal(){
            let total = 0.00
            if(this.numberTicketsRecharge === "" || this.numberTicketsRecharge === null){
                return total.toFixed(2)
            }
            
            total = parseFloat(this.numberTicketsRecharge) * 5.00

            return total.toFixed(2)
        }
    }
};
</script>

<style>
/* Ensure the container can properly hold absolute positioned elements */
.relative-container {
    position: relative;
    width: 100%;
}

/* Floating card style */
.floating-card {
    position: absolute!important;
    top: -180px;
    left: 50%;
    transform: translateX(-50%);
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
    display: flex;
    max-width: 600px;
    min-width: 300px;
    padding: 20px;
    z-index: 10;
}

/* QR Section */
.qr-section {
    flex-shrink: 0;
}

.qr-code {
    width: 80px;
    height: 80px;
    background-color: #f0f0f0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px;
}

.id-number {
    margin-top: 10px;
    font-family: monospace;
    font-size: 14px;
    text-align: center;
}

/* Highlight effect when input is focused */
.highlight {
    color: #09b6ac; /* Bright color */
    font-size: 1.7rem; /* Increase size */
    font-weight: bold;
    transition: all 0.3s ease-in-out;
}

/* Text Content */
.text-content {
    font-size: 12px;
    color: #333;
}

/* Add margin to the form to prevent overlap */
.form-container {
    margin-top: 120px;
}

#card_cvv_input, #number_tickets_release, #number_tickets_recharge, #number_tickets_transfer, #destiny_card_code{
    text-align: right;
}

.table_common_area thead tr th{
    background: #F3F2F7!important;
}

.table_common_area {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table_common_area .table {
  min-width: 600px;
}

.form-control{
    height: 50px!important;
}

.nav-item button{
    margin:0px!important;
}

/* Chrome, Safari, Edge, Opera: Ocultar flechas del input type="number" */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox: Ocultar flechas del input type="number" */
input[type=number] {
  -moz-appearance: textfield;
}
</style>